/* ==========================================================================
   custom-variant-picker.js — Mount Everest (2026-11-04)

   When a shopper clicks a value of the first option (Color) and the currently
   selected combination does not exist, or is sold out, for that value — e.g.
   Terracotta only comes in L while M is selected — the theme would render the
   page as "Unavailable" and keep the old image. This switches the other
   options (Size, …) to the first available variant of the chosen value *before*
   the theme fetches the new combination, so the image, price and button update
   right away. Product data comes from /products/<handle>.js, fetched once per
   product. If the data is not loaded yet, the theme's default behavior applies.
   Loaded from layout/theme.liquid with `defer`.
   ========================================================================== */
(function () {
  'use strict';

  var products = new Map();
  var pending = new Map();

  function load(handle) {
    if (!handle || products.has(handle) || pending.has(handle)) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var request = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (json) { if (json && Array.isArray(json.variants)) products.set(handle, json); })
      .catch(function () {})
      .then(function () { pending.delete(handle); });
    pending.set(handle, request);
  }

  function prime() {
    document.querySelectorAll('variant-picker[handle]').forEach(function (picker) {
      load(picker.getAttribute('handle'));
    });
  }

  function labelText(input) {
    var label = input.nextElementSibling;
    if (!(label instanceof HTMLLabelElement) && input.id) {
      label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    }
    return label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function position(input) {
    return parseInt(input.getAttribute('data-option-position'), 10);
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.checked) return;
    if (!input.hasAttribute('data-option-position') || input.hasAttribute('data-product-url')) return;
    if (position(input) !== 1) return;

    var picker = input.closest('variant-picker');
    if (!picker) return;
    var form = document.forms[picker.getAttribute('form-id')];
    var product = products.get(picker.getAttribute('handle'));
    if (!form || !product) return;

    var inputs = Array.prototype.filter.call(form.elements, function (el) {
      return el instanceof HTMLInputElement && el.type === 'radio' && el.hasAttribute('data-option-position');
    });
    var positions = Array.from(new Set(inputs.map(position))).sort(function (a, b) { return a - b; });
    var selected = positions.map(function (pos) {
      var checked = inputs.find(function (el) { return position(el) === pos && el.checked; });
      return checked ? labelText(checked) : null;
    });

    var exact = product.variants.find(function (variant) {
      return positions.every(function (pos, index) { return (variant.options[pos - 1] || '') === selected[index]; });
    });
    if (exact && exact.available) return;

    var chosen = labelText(input);
    var candidate = product.variants.find(function (variant) {
      return variant.options[0] === chosen && variant.available;
    });
    if (!candidate && !exact) {
      candidate = product.variants.find(function (variant) { return variant.options[0] === chosen; });
    }
    if (!candidate || (exact && candidate.id === exact.id)) return;

    positions.forEach(function (pos, index) {
      if (pos === 1) return;
      var wanted = candidate.options[pos - 1];
      if (selected[index] === wanted) return;
      var target = inputs.find(function (el) { return position(el) === pos && labelText(el) === wanted; });
      if (target) target.checked = true;
    });
  }, true);

  prime();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prime);

  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(prime, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
